<div class="w-full">
  <div class="divide-y divide-gray-200 overflow-hidden mt-5 bg-white shadow sm:rounded-lg">
    <div class="px-4 py-4 inline-flex w-full  sm:px-6 justify-content-between">
      <div class="text-2xl leading-6  text-gray-900">
        Umsatzverlauf
      </div>

      <div class="flex place-self-center ">
        <label class="sr-only" for="timelineBarChartSelection">Anzeigeoption</label>
        <select (ngModelChange)="changeOption($event)" [ngModel]="selectedOption"
                class=" block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                id="timelineBarChartSelection" name="timelineBarChartSelection">
          @for (option of revenueTimelineStore.options; track option.key) {
            <option [value]="option.key">{{ option.description }}</option>
          }
        </select>
      </div>
    </div>
    <div class="px-4 pb-3.5 pt-4 sm:p-6">
      <!--
        Chart.js sizing box (Bug #234): `w-full` is Tailwind, the old `w-100` was BOOTSTRAP
        (`width:100%!important`). `h-96` must stay on this wrapper — Chart.js derives the chart height from the
        canvas's PARENT, so an auto-height wrapper collapses the chart.
      -->
      <div class="w-full h-96 flex justify-content-center">

        @if (revenueTimelineStore.errorCode != undefined && revenueTimelineStore.errorCode != ErrorCodes.loading) {
          <analytics-error-message
            [analysisErrorState]="revenueTimelineStore.errorCode"></analytics-error-message>
        }

        @if (revenueTimelineStore.errorCode == ErrorCodes.loading) {
          <div
            class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status">
          </div>
        }

        <!-- `w-full` (Tailwind), not `w-100` (Bootstrap `!important`) — #234. Sizes the canvas only until
             Chart.js writes its own inline px width; both resolve to the wrapper's content width. -->
        <canvas #timelineRevenueChart [ngClass]="{ 'hidden': revenueTimelineStore.errorCode != undefined }"
                class="inline-flex sm:h-96 w-full"></canvas>
      </div>
    </div>
  </div>
  <app-tab-selection class="mt-3.5 block" (optionSelected)="changeTimeRange($event)"
                     [options]="timeIntervalOptions"
                     [selectedOption]="timeIntervalOptions[2]"></app-tab-selection>
</div>
